import { Switch } from "@/components/ui/switch";
import FormInputField from "@/components/lib/from-input-field";
import { Label } from "@/components/ui/label";
import SpiceSelector from "@/components/lib/SpiceSelector";
import { PenLine, Trash2 } from "lucide-react";
import { spiceLevels } from "@/assets/constans";
import CreateVariantDialog from "@/components/dialog/menu-manage/common-dialog/create-variant-dialog";
import CreateBase from "@/components/dialog/menu-manage/common-dialog/create-base";
import CreateToppings from "@/components/dialog/menu-manage/common-dialog/create-toppings";
import UpdateVariantDialog from "@/components/dialog/menu-manage/common-dialog/update-variant-dialog";
import CreateAddonsDialog from "@/components/dialog/menu-manage/common-dialog/create-addons";
import CreateAllergenDialog from "@/components/dialog/menu-manage/common-dialog/create-allergen";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "@/components/ui/table";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { calculatePriceWithVAT } from "@/lib/utils";
import { ButtonType } from "@/components/lib/Button";
import { useDispatch } from "react-redux";
import { deleteVariantById } from "@/redux/slice/essential-menu-slice/variants-slice";
import {
  fetchSinglePizza,
  updateExistingPizza,
} from "@/redux/slice/menu-manage-slice/pizza-slice";
import { Loader2 } from "lucide-react";
import { setItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import { toast } from "react-hot-toast";
import { DeleteConfirmDialog } from "@/components/dialog/common-dialog";

function Step2({ form, pizza_id, item_id }) {
  const dispatch = useDispatch();
  const [deleteDialog, setDeleteDialog] = useState(false);
  const add_on_ids = form.watch("add_on_ids");
  const allergen_ids = form.watch("allergen_ids");
  const spice_level = form.watch("spice_level");
  const [showAddons, setShowAddons] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAllergen, setShowAllergens] = useState(false);
  const [createVariantDialog, setCreateVariantDialog] = useState(false);
  const [updateVariantDialog, setUpdateVariantDialog] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [createNewAllergen, setCreateNewAllergen] = useState(false);
  const [basesDialgo, setBaseDialog] = useState(false);
  const [toppingsDialog, setToppingsDialog] = useState(false);
  const [showSpice, setShowSpice] = useState(false);
  const [createNewAddOn, setCreateNewAddOn] = useState(false);
  const { itemVariants } = useSelector((state) => state.essentialMenu.variants);
  const { addOns } = useSelector((state) => state.essentialMenu.addOns);
  const { bases } = useSelector((state) => state.essentialMenu.bases);
  const { toppings } = useSelector((state) => state.essentialMenu.toppings);
  const { allergens } = useSelector((state) => state.essentialMenu.allergens);

  useEffect(() => {
    const fetchSingleItem = async () => {
      try {
        const res = await dispatch(fetchSinglePizza(item_id));
        if (fetchSinglePizza.fulfilled.match(res)) {
          const item = res?.payload?.variants;
          dispatch(setItemVariants(item));
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchSingleItem();
  }, []);

  const handleVariantCreated = async (newVariantId) => {
    if (!newVariantId) return;
    setLoading(true);
    const allVariantIds = [...itemVariants.map((v) => v.id), newVariantId];
    form.setValue("variant_ids", allVariantIds);
    try {
      const res = await dispatch(
        updateExistingPizza({
          id: item_id,
          data: {
            status: `${
              form.watch("type") === "update" ? form.watch("status") : "draft"
            }`,
            variant_ids: allVariantIds,
          },
        })
      );
      if (updateExistingPizza.fulfilled.match(res)) {
        // toast.success("Drink updated with new variant successfully.");
      } else {
        // toast.error(res?.payload || "Failed to update the drink.");
      }
    } catch (error) {
      toast.error("Failed to update the item with new variant.");
    }
    setLoading(false);
  };

  const closeVariant = () => {
    setCreateVariantDialog(false);
  };
  const closeUpdateVariant = () => {
    setUpdateVariantDialog(false);
    setSelectedVariant(null);
  };
  const closeNewAllergen = () => {
    setCreateNewAllergen(false);
  };
  const closeCreateNewAdd = () => {
    setCreateNewAddOn(false);
  };

  useEffect(() => {
    setShowAllergens(Array.isArray(allergen_ids) && allergen_ids.length > 0);
    setShowAddons(Array.isArray(add_on_ids) && add_on_ids.length > 0);
    setShowSpice(!!spice_level);
  }, [add_on_ids, allergen_ids, spice_level]);

  const deleteHandler = async (id) => {
    try {
      if (!id) {
        toast.error("Variant ID is required to delete.");
        return;
      }
      const res = await dispatch(deleteVariantById(id));
      if (deleteVariantById.fulfilled.match(res)) {
        toast.success("Variant deleted successfully.");
        handleVariantCreated(id);
        setSelectedVariant(null);
        setDeleteDialog(false);
      } else if (deleteVariantById.rejected.match(res)) {
        toast.error(res?.payload || "Failed to delete the variant.");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    }
  };

  return (
    <Card className="max-w-screen-md bg-cblack6 mx-auto mt-10 text-cwhite">
      <CardHeader>
        <CardTitle>
          {" "}
          {form.watch("type") == "update"
            ? "Update Pizza"
            : "Add New Pizza"}{" "}
        </CardTitle>
        <CardDescription className="text-cyellow">
          Item name: {form.watch("name") || "No name"}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-5">
          <div className="flex justify-between items-center gap-5">
            <CardTitle>Varinat & Price</CardTitle>
            <ButtonType onClick={() => setCreateVariantDialog(true)}>
              Create New Variants & Price
            </ButtonType>
            <CreateVariantDialog
              crust={true}
              title={"Create New Variant & Price"}
              menu_id={pizza_id}
              onClose={closeVariant}
              isOpen={createVariantDialog}
              onSuccess={(newVariantId) => handleVariantCreated(newVariantId)}
              item_id={item_id}
              item_type="pizza"
            />
          </div>

          <div className="relative">
            <Table>
              <TableHeader>
                <TableRow>
                  {/* <TableHead>Select</TableHead> */}
                  <TableHead>Crust</TableHead>
                  <TableHead>Size</TableHead>
                  <TableHead>Calorie</TableHead>
                  <TableHead>In-Price(exc VAT)</TableHead>
                  <TableHead>In-Price(inc VAT)</TableHead>
                  <TableHead>Out-Price(exc VAT)</TableHead>
                  <TableHead>Out-Price(inc VAT)</TableHead>
                  <TableHead className="text-right">Action</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody>
                {itemVariants && itemVariants?.length > 0 ? (
                  itemVariants?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell>
                          {item?.crust_name || item?.crust || "No crust"}
                        </TableCell>
                        <TableCell>{item?.name || "No name"}</TableCell>
                        <TableCell>
                          {item?.calorie_amount || "0"} kcal
                        </TableCell>
                        <TableCell>${item?.in_price || "0"}</TableCell>
                        <TableCell>
                          ${calculatePriceWithVAT(item?.in_price, 0) || "0"}
                        </TableCell>
                        <TableCell>${item?.out_price || "0"}</TableCell>
                        <TableCell>
                          ${calculatePriceWithVAT(item?.out_price, 0) || "0"}
                        </TableCell>
                        <TableCell>
                          <div className="flex gap-2 justify-end items-center">
                            <span>
                              <PenLine
                                onClick={() => {
                                  setUpdateVariantDialog(true);
                                  setSelectedVariant(item);
                                }}
                                className="text-cgreen cursor-pointer"
                                size={18}
                              />
                            </span>
                            <Trash2
                              onClick={() => {
                                setDeleteDialog(true);
                                setSelectedVariant(item);
                              }}
                              className="text-cred cursor-pointer"
                              size={18}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} className="text-center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            {loading && (
              <div className="absolute inset-0 bg-black/40 flex justify-center items-center z-10">
                <Loader2 className="animate-spin" size={18} />
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-8 mt-5">
          <div className="flex justify-between items-end gap-5">
            <div className="flex flex-col w-full">
              <div className="w-full mt-3">
                <FormInputField
                  name="base_id"
                  type="select"
                  label="Base"
                  parseAs="string"
                  style="w-full bg-cblack7"
                  placeholder="Select base"
                  selectOption={bases?.filter((item) => item?.status === "active")?.map((item) => ({
                    label: item.name,
                    value: item.id,
                  }))}
                  form={form}
                />
              </div>
            </div>

            <ButtonType onClick={() => setBaseDialog(true)}>
              Create New Base
            </ButtonType>
            <CreateBase
              title={"Create New Base"}
              menu_id={pizza_id}
              onClose={() => setBaseDialog(false)}
              isOpen={basesDialgo}
            />
          </div>

          <div className="flex justify-between items-end gap-5">
            <div className="flex flex-col w-full">
              <div className="w-full mt-3">
                <FormInputField
                  name="topping_ids"
                  type="multiselect"
                  label="Toppings"
                  style="w-full bg-cblack7"
                  placeholder="Select Toppings"
                  selectOption={toppings?.filter((item) => item?.status === "active")?.map((item) => ({
                    label: item.name,
                    value: item.id,
                  }))}
                  form={form}
                />
              </div>
            </div>

            <ButtonType onClick={() => setToppingsDialog(true)}>
              Create New Toppings
            </ButtonType>
            <CreateToppings
              title={"Create New Toppings"}
              menu_id={pizza_id}
              onClose={() => setToppingsDialog(false)}
              isOpen={toppingsDialog}
            />
          </div>

          <div className="flex justify-between items-end gap-5">
            <div className="flex flex-col w-full">
              <div className="flex gap-2 items-center w-full">
                <Switch
                  checked={showAddons}
                  onCheckedChange={(val) => {
                    setShowAddons(val);
                    if (!val) {
                      form.setValue("add_on_ids", []);
                    }
                  }}
                />
                <Label>Add-ons</Label>
              </div>
              {showAddons && (
                <div className="w-full mt-3">
                  <FormInputField
                    name="add_on_ids"
                    type="multiselect"
                    label="Add Ons"
                    style="w-full bg-cblack7"
                    placeholder="Select Add Ons"
                    selectOption={
                      addOns && addOns?.length > 0
                        ? addOns
                          .filter((item) => item?.status === "active")
                          .map((item) => ({
                            label: item.name,
                            value: item.id,
                          }))
                        : [
                            {
                              label: "Not available",
                              value: "",
                              disabled: true,
                            },
                          ]
                    }
                    form={form}
                  />
                </div>
              )}
            </div>
            {showAddons && (
              <ButtonType onClick={() => setCreateNewAddOn(true)}>
                Create New Add-ons
              </ButtonType>
            )}
            <CreateAddonsDialog
              title={"Create New Add-ons"}
              menu_id={pizza_id}
              onClose={closeCreateNewAdd}
              isOpen={createNewAddOn}
            />
          </div>

          <div>
            <div className="flex gap-5 justify-between items-end">
              <div className="w-full">
                <div className="flex gap-2 items-center">
                  <Switch
                    checked={showAllergen}
                    onCheckedChange={(val) => {
                      setShowAllergens(val);
                      if (!val) {
                        form.setValue("allergen_ids", []);
                      }
                    }}
                  />
                  <Label>
                    Allergen{" "}
                    <span className="text-sm font-light">(shows on items)</span>
                  </Label>
                </div>
                {showAllergen && (
                  <div className="space-y-2 flex mt-2 w-full">
                    <FormInputField
                      name="allergen_ids"
                      style="bg-cblack7 flex-1"
                      placeholder={"Select Allergens"}
                      form={form}
                      type="multiselect"
                      label={"Allergens"}
                      selectOption={
                        allergens && allergens?.length > 0
                          ? allergens
                            .filter((item) => item?.status === "active")
                            .map((item) => ({
                              label:
                                item.name +
                                (item?.short_name ? ` (${item.short_name})` : ""),
                              value: item.id,
                            }))
                          : [
                              {
                                label: "Not available",
                                value: "",
                                disabled: true,
                              },
                            ]
                      }
                    />
                  </div>
                )}
              </div>
              {showAllergen && (
                <ButtonType onClick={() => setCreateNewAllergen(true)}>
                  Create New Allergen
                </ButtonType>
              )}
              <CreateAllergenDialog
                menu_id={pizza_id}
                title={"Create New Allergen"}
                onClose={closeNewAllergen}
                isOpen={createNewAllergen}
              />
            </div>
          </div>
          <div>
            <div className="flex gap-5 justify-between items-end ">
              <div className="w-full">
                <SpiceSelector form={form} />
              </div>
            </div>
          </div>
        </div>
      </CardContent>

      <UpdateVariantDialog
        crust={true}
        onClose={closeUpdateVariant}
        isOpen={updateVariantDialog}
        title="Update New Variant & Price"
        variantData={selectedVariant}
      />
      <DeleteConfirmDialog
        isOpen={deleteDialog}
        onClose={() => setDeleteDialog(false)}
        onConfirm={() => {
          deleteHandler(selectedVariant.id);
        }}
        personName={""}
      />
    </Card>
  );
}

export default Step2;
